import Link from 'next/link'
import { BarChart3, ChevronRight } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { navigation } from '@/lib/docs-navigation'

export function DocsPage() {
  const links = navigation.flatMap((section) =>
    section.links.map((link) => ({
      ...link,
      section: section.title,
    })),
  )

  return (
    <div className="space-y-6">
      <PageHeader
        title="Documentation"
        description="Tarifix operations and integration references"
        breadcrumbs={[{ label: 'Documentation' }]}
      />

      <div className="grid gap-4 xl:grid-cols-2">
        {links.map((link) => (
          <Link key={link.href} href={link.href}>
            <Card className="h-full transition-colors hover:bg-muted/60">
              <CardHeader>
                <CardDescription className="flex items-center gap-2">
                  <BarChart3 className="h-4 w-4" />
                  {link.section}
                </CardDescription>
                <CardTitle className="flex items-center justify-between gap-3 text-base">
                  {link.title}
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Open the {link.title.toLowerCase()} reference.
                </p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
